// extracted by mini-css-extract-plugin
export default {"croppingHint":"RmbzjNLYyaXV0XNwn97G"};